import React, { Component } from "react";
import SentMessagesRow from "./SentMessagesRow";
import SentMessageModal from "./SentMessageModdal";

class SentMessagesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sentmessages: [[new Date().getTime(), "fakemessage"]],
      modal: { visible: false }
    };
  }
  componentDidMount() {
    fetch("/sentmessages")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        this.setState({ sentmessages: data.sentmessages });
      });
  }
  _callbackStateModal = message => {
    console.log("callback called: " + message[0]);
    let newModal = JSON.parse(JSON.stringify(this.state.modal));
    console.log(newModal);
    newModal.visible = this.state.modal.visble ? false : true;
    newModal.timestamp = message[0];
    newModal.content = message[1];
    console.log(newModal);
    this.setState({ modal: newModal });
  };

  render() {
    return (
      <div>
        <table className="table table-striped table-sm">
          <thead className="thead-dark">
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Message</th>
              <th>#Sent</th>
              <th>#Received</th>
              <th>#Confirmed</th>
              <th>Stats</th>
            </tr>
          </thead>
          <tbody>
            {this.state.sentmessages.map(sentmessage => (
              <SentMessagesRow
                key={sentmessage}
                sentmessage={sentmessage}
                _callbackStateModal={this._callbackStateModal}
              />
            ))}
          </tbody>
        </table>
        <SentMessageModal modal={this.state.modal} />
      </div>
    );
  }
}

export default SentMessagesTable;
